import { InitialCarePlan } from '@seen/core/models/care-plans/InitialCarePlan'
import type { JSX } from 'react'
import { Navigate } from 'react-router'
import { NoCarePlan } from '#src/components/care-plan/NoCarePlan.tsx'
import { Loader } from '#src/components/core/Loader.tsx'
import { useCurrentParticipant } from '#src/contexts/current-participant/useCurrentParticipant.ts'
import { useSearch } from '#src/hooks/useSearch.ts'

export function CarePlanRootPage(): JSX.Element {
  const participant = useCurrentParticipant()
  const carePlansQuery = useSearch(
    InitialCarePlan,
    InitialCarePlan.byParticipant(participant.reference)
  )

  if (carePlansQuery.isPending) {
    return <Loader />
  }

  if ((carePlansQuery.data ?? []).length > 0) {
    return <Navigate to="history" replace />
  }

  return <NoCarePlan />
}
